import React from 'react';
import { Shield, AlertTriangle, CheckCircle, XCircle } from 'lucide-react';

const complianceMetrics = [
  {
    category: 'Documentation',
    status: 'success',
    score: 98,
    issues: 0,
    details: 'All required documents properly formatted and submitted',
  },
  {
    category: 'Technical Requirements',
    status: 'warning',
    score: 85,
    issues: 2,
    details: 'Minor gaps in technical specifications',
  },
  {
    category: 'Past Performance',
    status: 'success',
    score: 95,
    issues: 0,
    details: 'Strong track record with similar contracts',
  },
  {
    category: 'Pricing Structure',
    status: 'error',
    score: 75,
    issues: 3,
    details: 'Pricing justification needs additional detail',
  },
];

export function ComplianceOverview() {
  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Shield className="h-6 w-6 text-purple-500" />
          <h2 className="text-lg font-medium text-gray-900">Compliance Overview</h2>
        </div>
      </div>

      <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {complianceMetrics.map((metric) => (
          <div
            key={metric.category}
            className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm"
          >
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium text-gray-900">{metric.category}</h3>
              {metric.status === 'success' ? (
                <CheckCircle className="h-5 w-5 text-green-500" />
              ) : metric.status === 'warning' ? (
                <AlertTriangle className="h-5 w-5 text-yellow-500" />
              ) : (
                <XCircle className="h-5 w-5 text-red-500" />
              )}
            </div>
            <div className="mt-2">
              <div className="flex items-baseline">
                <p className="text-2xl font-semibold text-gray-900">{metric.score}%</p>
                <span
                  className={`ml-2 rounded-full px-2.5 py-0.5 text-xs font-medium ${
                    metric.issues === 0
                      ? 'bg-green-100 text-green-800'
                      : 'bg-red-100 text-red-800'
                  }`}
                >
                  {metric.issues} issues
                </span>
              </div>
              <p className="mt-1 text-sm text-gray-500">{metric.details}</p>
            </div>
            <div className="mt-4">
              <div className="h-2 w-full rounded-full bg-gray-200">
                <div
                  className={`h-2 rounded-full ${
                    metric.score >= 90
                      ? 'bg-green-500'
                      : metric.score >= 80
                      ? 'bg-yellow-500'
                      : 'bg-red-500'
                  }`}
                  style={{ width: `${metric.score}%` }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}